<template>
    <div class="sa-list-component">
        <div class="sa-list-component-body">
            <div class="sa-test" style="height: 100%" v-if="view === 'card'">
                <div class="sa-card-list sa-flexbox-flex-direction-column">
                    <div class="sa-flexbox-column-content">
                        <b-row style="flex: 1">
                            <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                                <div class="sa-flexbox-column-content-main">
                                    <b-row @dragover.prevent @drop.self="onDrop(null)">
                                        <b-col v-for="(item, index) of listaPazientiProgrammati" :key="index" class="sa-card-list-col" cols="12" xs="12" sm="12" md="6" lg="6" xl="6" draggable="true" @dragend="onDragEnd" @dragstart="onDragStart(item, index, $event)" @dragenter.prevent @dragleave.prevent @drop="onDrop(index)">
                                            <div class="sa-card-list-container">
                                                <div v-if="item.regime === 'AMBULATORIALE'" class="sa-card-list-container-header">Regime Ambulatoriale</div>
                                                <div v-else class="sa-card-list-container-header">{{ item.denominazionePresidio }} - {{ item.nomeStanza }} - {{ item.nomeLetto }}</div>
                                                <div class="sa-card-list-container-body">
                                                    <div>
                                                        <img v-if="item.sesso === 'M'" src="@/assets/images/ico_m.png" />
                                                        <img v-else src="@/assets/images/ico_f.png" />
                                                    </div>
                                                    <div style="flex: 1; padding-left: 5px">
                                                        <span class="sa-card-list-container-body-row">
                                                            <b>{{ item.cognome + " " + item.nome }}</b>
                                                        </span>
                                                        <span class="sa-card-list-container-body-row">Data Nascita: {{ formatDate(item.dataNascita) }}</span>
                                                        <!--   <span class="sa-card-list-container-body-row">Da: </span>
                                                        <span class="sa-card-list-container-body-row">A: </span> -->
                                                        <span class="sa-card-list-container-body-row-ballon">{{ index + 1 }}</span>
                                                    </div>
                                                </div>
                                                <div class="sa-card-list-container-footer text-right">
                                                    <b-button size="sm" v-if="item.regime === 'SEMIRESIDENZIALE'" v-b-tooltip.hover title="Rimuovi dai Programmati" variant="outline-danger outline-secondary-noborder pull-right" @click="onClickRimuoviDaiProgrammati(item)" class="mr-1 no-text">
                                                        <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
                                                    </b-button>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                <div class="sa-flexbox-column-content-right">
                                    <b-card class="sa-card sa-card-border sa-card-inactive-body" header="Lista Pazienti" header-tag="header" footer-tag="footer" title="">
                                        <b-row>
                                            <!-- <b-row @dragover.prevent @drop.self="onDrop(null)"> -->
                                            <b-col v-for="(item, index) of listaPazientiFiltrati" :key="item.id || index" class="sa-card-list-col" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" draggable="false" @dragend="onDragEnd" @dragstart="onDragStart(item, index, $event)" @dragenter.prevent @dragleave.prevent @drop="onDrop(index)">
                                                <div class="sa-card-list-container sa-card-list-container-inactive">
                                                    <div v-if="item.regime === 'AMBULATORIALE'" class="sa-card-list-container-header">Regime Ambulatoriale</div>
                                                    <div v-else class="sa-card-list-container-header">{{ item.denominazionePresidio }} - {{ item.nomeStanza }} - {{ item.nomeLetto }}</div>
                                                    <div class="sa-card-list-container-body">
                                                        <div>
                                                            <img v-if="item.sesso === 'M'" src="@/assets/images/ico_m.png" />
                                                            <img v-else src="@/assets/images/ico_f.png" />
                                                        </div>
                                                        <div style="flex: 1; padding-left: 5px">
                                                            <span class="sa-card-list-container-body-row">
                                                                <b>{{ item.cognome + " " + item.nome }}</b>
                                                            </span>
                                                            <span class="sa-card-list-container-body-row">Data Nascita: {{ formatDate(item.dataNascita) }}</span>
                                                            <!--   <span class="sa-card-list-container-body-row">Da: </span>
                                                            <span class="sa-card-list-container-body-row">A: </span> -->
                                                        </div>
                                                    </div>
                                                    <div class="sa-card-list-container-footer text-right">
                                                        <b-button v-b-tooltip.hover size="sm" variant="outline-success outline-secondary-noborder pull-right" title="Programma" @click="onClickAggiungiProgrammati(item)" class="sa-icon-rotate">
                                                            <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
                                                        </b-button>
                                                        <!-- <b-button size="sm" v-if="item.regime === 'RESIDENZIALE'" v-b-tooltip.hover title="Cambio Posto Letto" variant="outline-success outline-secondary-noborder pull-right" @click="onClickRicovera(item)" class="mr-1 no-text">
															<font-awesome-icon icon="bed" />
														</b-button>
														<template v-if="item.statoAttuale === 'RICOVERATO'">
															<b-button v-b-tooltip.hover size="sm" variant="outline-purple outline-secondary-noborder pull-right" title="Registra Uscita" @click="onClickPresenzaUscita(item)" class="mr-1">
																<font-awesome-icon :icon="['fas', 'sign-out-alt']" />
															</b-button>
														</template>
<b-button v-else v-b-tooltip.hover size="sm" variant="outline-danger outline-secondary-noborder pull-right"
	title="Registra Entrata" @click="onClickPresenzaEntrata(item)" class="sa-icon-rotate">
	<font-awesome-icon :icon="['fas', 'sign-in-alt']" />
</b-button> -->
                                                        <!-- <print-component :linkPrintReport="linkPrintReport(item)" :typeButton="'small'" :documentRepository="false"></print-component> -->
                                                    </div>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </b-card>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            pathResource: "/rsaaccettazionesemiresidenziale/programmati",
            pathResourceListaPazienti: "/rsaospiti/pazientisemiresidenziale",
            view: "card",
            rows: 0,
            perPage: 0,
            currentPage: 1,
            filtroGestioneCentroDiurno: null,
            listaPazientiProgrammati: [
                // { id: 1, denominazionePresidio: "Kekko è Strunz", cognome: "Kekko", sesso: "M", nome: "Strunz", dataNascita: 0 },
                // { id: 2, denominazionePresidio: "Kekko è Strunz", cognome: "Strunz", sesso: "F", nome: "Kekko", dataNascita: 0 },
                // { id: 3, denominazionePresidio: "Kekko è Strunz", cognome: "Agg Rit", sesso: "M", nome: "Kekko Strun", dataNascita: 0 },
                // { id: 4, denominazionePresidio: "Kekko è Strunz", cognome: "Agg Rit", sesso: "M", nome: "Kekko Strun Assai", dataNascita: 0 },
                // { id: 5, denominazionePresidio: "Kekko è Strunz", cognome: "Kekko", sesso: "M", nome: "Strunz", dataNascita: 0 },
                // { id: 6, denominazionePresidio: "Kekko è Strunz", cognome: "Strunz", sesso: "F", nome: "Kekko", dataNascita: 0 },
                // { id: 7, denominazionePresidio: "Kekko è Strunz", cognome: "Agg Rit", sesso: "M", nome: "Kekko Strun", dataNascita: 0 },
                // { id: 8, denominazionePresidio: "Kekko è Strunz", cognome: "Agg Rit", sesso: "M", nome: "Kekko Strun Assai", dataNascita: 0 },
            ],
            listaPazienti: [],
            listaPazientiFiltrati: [],
            // Variabili per la gestione del D&D nativo
            draggedItem: null,
            draggedItemIndex: -1,
            empDragImage: null,
        };
    },
    mounted() {},
    methods: {
        loadData(filtroGestioneCentroDiurno) {
            this.filtroGestioneCentroDiurno = filtroGestioneCentroDiurno;
            this.loadDataListaPazienti();
        },
        loadDataProgrammati() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            axios
                .get(link, { params: this.filtroGestioneCentroDiurno })
                .then((response) => {
                    me.listaPazientiProgrammati = [];
                    me.listaPazientiProgrammati = response.data.data.list;
                    me.setListaPazientiFiltrati();
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        loadDataListaPazienti() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceListaPazienti;
            axios
                .get(link, { params: this.filtroGestioneCentroDiurno })
                .then((response) => {
                    me.listaPazienti = [];
                    me.listaPazienti = response.data.data.list;
                    me.listKey++;
                    this.loadDataProgrammati();
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        setListaPazientiFiltrati() {
            this.listaPazientiFiltrati = [];
            for (let paziente of this.listaPazienti) {
                if (!this.listaPazientiProgrammati.some((e) => e.id == paziente.id)) {
                    this.listaPazientiFiltrati.push(paziente);
                }
            }
        },
        linkPrintReport() {},
        onDragStart(item, index, event) {
            // Riferimento all'elemento DOM che si sta trascinando
            this.draggedElement = event.currentTarget;

            // Aggiunge la classe che vogliamo usare per marcare l'elemento

            //this.draggedElement = event.currentTarget;

            // Passo 1: Disabilitare la trasparenza sull'Immagine Fantasma
            if (event.dataTransfer && this.draggedElement) {
                console.log("Uno");
                // Imposta l'elemento originale come immagine fantasma.
                // Il browser la renderà alla sua opacità normale (senza l'opacità di default del drag).
                // 0, 0 sono le coordinate di offset rispetto al cursore (opzionali).
                event.dataTransfer.setDragImage(this.draggedElement, 0, 0);

                event.dataTransfer.effectAllowed = "move";
            }

            // Passo 2: Rendi l'Elemento Originale (quello che rimane indietro) invisibile
            // In questo modo, vedi solo l'immagine fantasma NON trasparente che si muove.
            // this.draggedElement.classList.add('hide-original-while-dragging');
            this.draggedElement.classList.add("is-dragging");
            this.draggedItem = item;
            this.draggedItemIndex = index;
            // Opzionale: Aggiungere una classe per feedback visivo
            // event.dataTransfer.effectAllowed = 'move';
        },
        onDrop(targetIndex) {
            console.log(targetIndex);
            // Se non c'è un item trascinato o il rilascio è sull'indice di partenza, non fare nulla
            if (!this.draggedItem || this.draggedItemIndex === targetIndex) {
                this.draggedItem = null;
                this.draggedItemIndex = -1;
                return;
            }

            let newIndex = targetIndex === null ? this.listaPazientiProgrammati.length - 1 : targetIndex;

            // 1. Rimuovi l'elemento dalla sua posizione originale
            this.listaPazientiProgrammati.splice(this.draggedItemIndex, 1);

            // 2. Inserisci l'elemento nella nuova posizione
            // Dobbiamo ricalcolare newIndex perché la rimozione ha accorciato l'array
            if (this.draggedItemIndex < newIndex) {
                // Se lo spostiamo in basso, l'indice di destinazione è ora uno in meno
                newIndex = newIndex - 1;
            } else if (targetIndex === null) {
                // Se dropped sul container (null), significa dopo l'ultimo elemento attuale.
                newIndex = this.listaPazientiProgrammati.length;
            }

            // Inserisci l'elemento trascinato nella nuova posizione
            this.listaPazientiProgrammati.splice(newIndex, 0, this.draggedItem);

            // 3. Resetta le variabili di stato
            this.draggedItem = null;
            this.draggedItemIndex = -1;

            // Opzionale: Qui puoi chiamare la tua API per salvare il nuovo ordine
            // this.saveNewOrder(this.listaPazientiProgrammati);
            //console.log("Nuovo ordine degli listaPazientiProgrammati:", this.listaPazientiProgrammati);
        },
        salvaProgrammazione() {
            this.openShowModalLoading();
            let me = this;
            let pathResource = "/rsaaccettazionesemiresidenziale";
            let link = process.env.VUE_APP_PATH_API + pathResource + "/posizioni";
            let bodyParams = [];
            this.listaPazientiProgrammati.forEach((element) => {
                bodyParams.push({ id: element.idProgrammazione, posizione: element.posizione });
            });
            axios
                .put(link, bodyParams)
                .then(() => {
                    me.closeShowModalLoading();
                })
                .catch(() => {
                    me.closeShowModalLoading();
                    this.$emit("afterLoadData");
                });
            console.log("Salva Programmazione Uno");
        },
        onDragEnd() {
            // Rimuove la classe di marcatura dall'elemento DOM salvato
            if (this.draggedElement) {
                this.draggedElement.classList.remove("is-dragging");
                this.draggedElement = null;
            }
        },
        onClickRimuoviDaiProgrammati(item) {
            this.$bvModal
                .msgBoxConfirm(`Rimuovere ${item.cognome} - ${item.nome} dalla programmazione per il giorno  ${this.formatDate(this.filtroGestioneCentroDiurno.dataRiferimento)} ?`, {
                    title: "ATTENZIONE",
                    size: "md",
                    okTitle: "Rimuovi",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                })
                .then((value) => {
                    if (value) this.rimuoviDaiProgrammati(item);
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        rimuoviDaiProgrammati(item) {
            this.openShowModalLoading();
            // let sendObj = {
            // 	id: item.idProgrammazione,
            // 	idAccettazione: item.primaryKey,
            // 	dataRiferimento: this.filtroGestioneCentroDiurno.dataRiferimento,
            // 	posizione: item.posizione,
            // };
            UtilityMixin.methods.deleteResource(this.pathResource + "/" + item.idProgrammazione, this.rimuoviDaiProgrammatiSuccess, this.rimuoviDaiProgrammatiError);
        },
        rimuoviDaiProgrammatiSuccess() {
            this.closeShowModalLoading();
            this.loadData(this.filtroGestioneCentroDiurno);
        },
        rimuoviDaiProgrammatiError(error) {
            console.log(error);
            this.closeShowModalLoading();
            this.loadData(this.filtroGestioneCentroDiurno);
        },

        onClickAggiungiProgrammati(item) {
            this.$bvModal
                .msgBoxConfirm(`Aggiungere ${item.cognome} - ${item.nome} alla programmazione per il giorno  ${this.formatDate(this.filtroGestioneCentroDiurno.dataRiferimento)} ?`, {
                    title: "Azione Obbligatoria",
                    size: "md",
                    okTitle: "Aggiungi",
                    okVariant: "outline-success",
                    headerClass: "sa-msg-header-success",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                })
                .then((value) => {
                    if (value) this.programma(item);
                })
                .catch((err) => {
                    console.log(err);
                });
            // console.log(item);
        },
        programma(item) {
            this.openShowModalLoading();
            let sendObj = {
                idAccettazione: item.primaryKey,
                dataRiferimento: this.filtroGestioneCentroDiurno.dataRiferimento,
                posizione: this.listaPazientiProgrammati.length + 1,
            };
            this.saveResource(this.pathResource, sendObj, this.programmaSaveSuccess, this.programmaError);
        },
        programmaSaveSuccess() {
            this.closeShowModalLoading();
            this.loadData(this.filtroGestioneCentroDiurno);
        },
        programmaError(error) {
            console.log(error);
            this.closeShowModalLoading();
            this.loadData(this.filtroGestioneCentroDiurno);
        },
        onModificaPosizionamento() {
            console.log("on modifica posizionamento");
        },
    },
};
</script>

<style>
.sa-card-list-col.is-dragging {
    opacity: 0.9 !important;
    cursor: grabbing;
}
</style>
